/*
 * @Description: 名单库添加
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-10 13:57:25
 */
import { protocolService } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

const example = new TableRenderClass({ fields, search });

const part = example.createPart({
  name: '添加任务量',
  // list: invoice.invoiceOpenList,
  list: protocolService.listPeopleByProjectId,

  requestNow: true,
  search: ['fullName', 'phone'],
  fields: ['selection', 'index', 'fullName', 'phone', 'taskNum']
});

export default [{ name: '添加任务量', childMenu: [part] }];
